import React from 'react'
import '../../Styles/about/Decorations.styles.scss';

export const Decorations = () => {
    return (
        <>
            <div className='ballblinking police1'></div>
            <div className='ballblinking police2'></div>
            <div className='ballblinking police3'></div>
            <div className='ballblinking police4'></div>
            <div className='ballblinking police5 police4'></div>
            <div className='section-name-container'><span className='section-name'>ABOUT</span></div>
            <div className='stand sright'></div>
            <div className='stand'></div>
            <div className='lamp lright'></div>
            <div className='lamp'></div>
        </>
    )
}
